module.exports = __webpack_public_path__ + "static/img/xwnn.9862262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xwnn.png
// module id = F7yf
// module chunks = 1